import { DoubleSide } from "three/src/constants";
import { useState, useEffect, useRef } from "react";
import { VideoTexture } from "three/src/textures/VideoTexture";
import { Color } from "three/src/math/Color";
import { GreenScreenShader } from "../../utils/GreenScreenShader";
import { CDN_URL } from "../../constant";

function VideoPlane({ inlineVideoSpot, selectObject }) {
	const mesh = useRef(null);
	const [texture, setTexture] = useState(null);
	const [video] = useState(() => {
		const vid = document.createElement("video");
		vid.src = CDN_URL + inlineVideoSpot.url;
		vid.crossOrigin = "Anonymous";
		vid.loop = true;
		vid.muted = true;
		return vid;
	});
	useEffect(() => {
		void video.play();
		const tex = new VideoTexture(video);
		setTexture(tex);
	}, [video]);

	return (
		<>
			<mesh
				renderOrder={999}
				ref={mesh}
				position={inlineVideoSpot.position}
				rotation={inlineVideoSpot.rotation}
				scale={inlineVideoSpot.scale}
				onClick={(e) => {
					selectObject(inlineVideoSpot, mesh.current);
				}}
			>
				<planeGeometry attach="geometry" />
				{inlineVideoSpot.isChroma ? (
					<shaderMaterial
						attach="material"
						transparent
						toneMapped={true}
						depthWrite={false}
						side={DoubleSide}
						args={[
							{
								...GreenScreenShader,
								uniforms: {
									tex: { value: texture },
									keyColor: {
										value: new Color(
											inlineVideoSpot.chromaKey
										),
									},
									similarity: {
										value: 0.4,
									},
									smoothness: {
										value: 0.08,
									},
									spill: {
										value: 0.01,
									},
								},
							},
						]}
					/>
				) : (
					<meshBasicMaterial
						toneMapped={true}
						depthWrite={false}
						side={DoubleSide}
					>
						<videoTexture attach="map" args={[video]} />
					</meshBasicMaterial>
				)}
			</mesh>
		</>
	);
}

export default VideoPlane;
